import { useEffect, useState, useContext } from "react";
import { Link, useNavigate } from 'react-router-dom';

import { TbSearch } from "react-icons/tb";
import { CgShoppingCart } from "react-icons/cg";
import { AiOutlineHeart } from "react-icons/ai";
import { Categorry } from "../Category/Categorry"
import  Search  from "./Search/Search";
import Cart from '../Cart/Cart';
import { Context } from "../../utils/context"

import "./Header.scss";


const Header = () => {

    const [scrolled, setScrolled] = useState(false);
    const [showCart, setShowCart] = useState(false);
    const [showSearch, setShowSearch] = useState(false);
    

    useEffect(() => {
        console.log("useEffect");
    }, []);

    return(
        <>
            <header className={`main-header ${scrolled ? "sticky-header" : ""}`}>

                <div className="header-content">
                    <ul className="left">
                    <Link to="/"><li>Home</li> </Link>
                    <Link to="/about"> <li>About</li> </Link>
                        <Link to="/category/2"> <li>Categories</li> </Link>
                    </ul>
                    <div className="center"> DELUXIA </div>
                    <div className="right">
                           <TbSearch onClick={()=> setShowSearch(true)}/>
                           <AiOutlineHeart />
                        <span className="cart-icon" onClick={()=> setShowCart(true)}>
                           <CgShoppingCart/>
                           <span>5</span>
                        </span>
                        
                    </div>
                </div>
            </header>
            {showCart && <Cart setShowCart={setShowCart} />}
            {showSearch && <Search setShowSearch={setShowSearch} />} 
        </>
    ) 
};

export default Header;

